export default {
  // ---------------------------------------------------------------------------------------------
  // Die Reiterleiste der Zeiterfassung. Nur die beiden Warteschlangen tragen eine Zahl, und der
  // Hinweis dahinter nennt den Zeitraum: die Leiste steht auf allen sechs Seiten, ihr Zeitraum ist
  // deshalb keiner, den jemand ausgewählt hat, und darf nicht stillschweigend für die Auswahl der
  // Seite darunter gehalten werden.
  nav: {
    // Beide erklären eine nackte Zahl, also fangen sie bei ihr an und sagen erst dann, worüber
    // gezählt wurde. Vorher stand das Fenster als Klammerzusatz dahinter, was sich wie eine
    // Fußnote las statt wie ein Satz — und es ist die Angabe, auf die es hier ankommt: die Seite
    // darunter kann längst einen anderen Zeitraum und eine andere Auswahl zeigen.
    badge_behind:
      "So vielen Mitarbeitern fehlt im laufenden Monat mindestens ein Tag, über die ganze Belegschaft gezählt.",
    badge_violations:
      "So viele Verstöße gegen das Arbeitszeitgesetz hat der laufende Monat, über die ganze Belegschaft gezählt.",
  },
  // Der eine Satz für "wird gerade geholt", überall dort, wo sonst ein Leerzustand stünde. Ein
  // Leerzustand ist eine Aussage über Daten ("niemand ist eingestempelt", "kein Verstoß gefunden"),
  // und solange die Antwort noch unterwegs ist, ist jede dieser Aussagen unbelegt — der Ladebalken
  // darüber sagt bereits etwas anderes. Bewusst ohne Gegenstand: derselbe Satz steht über Konten,
  // Verstößen, der Anwesenheitstafel und dem Wochenraster.
  loading: "Wird geladen …",
  my: {
    empty: "Für diese Woche ist noch nichts erfasst.",
    title: "Meine Zeiten",
    subtitle: "Ihre Woche auf einen Blick: Beginn, Ende und Pausen.",
    add: "Zeit erfassen",
    // Die Begriffe der Stempeluhr. "Kommen"/"Gehen" ist zwar das, was auf dem Bau gesagt wird, als
    // Aufschrift einer einzelnen Schaltfläche aber mehrdeutig: sie liest sich als Ortsangabe, nicht
    // als Vorgang. "Einstempeln" versteht jeder sofort und meint genau diesen einen Vorgang.
    clock_in: "Einstempeln",
    clock_out: "Ausstempeln",
    previous_week: "Vorherige Woche",
    next_week: "Nächste Woche",
    this_week: "Diese Woche",
    // Steht in der Liste dort, wo sonst das Ende steht. Vorher stand da "…", was aussieht, als
    // fehle etwas — dabei ist es der Normalzustand eines noch laufenden Tages.
    still_running: "läuft",
    saved: "Zeit gespeichert.",
    // Die Eingaben bleiben im Formular stehen, wenn der Server die Zeit ablehnt. Der Grund steht
    // bereits als Fehlermeldung auf dem Bildschirm; dieser Satz sagt, dass nichts verloren ist.
    save_failed: "Die Zeit wurde nicht gespeichert. Ihre Eingaben stehen noch im Formular.",
    delete: "Löschen",
    delete_title: "Zeit löschen?",
    delete_text: "Der Eintrag vom {date} wird gelöscht. Das lässt sich nicht rückgängig machen.",
    deleted: "Zeit gelöscht.",
    // "Verwerfen" und nicht "Löschen": bei einer laufenden Erfassung gibt es noch nichts zu löschen,
    // es wird nur das versehentliche Kommen zurückgenommen.
    discard: "Verwerfen",
    discard_running_title: "Laufende Erfassung verwerfen?",
    discard_running_text: "Die seit {time} Uhr laufende Erfassung wird zurückgenommen. Es wird keine Zeit gespeichert.",
    discarded: "Erfassung verworfen.",
    clocked_out: "Ausgestempelt um {time} Uhr · {hours} Std. Arbeitszeit.",
    // Der Server nimmt das Einstempeln zurück, wenn beides in derselben Sekunde liegt. Ohne diesen
    // Satz verschwindet der Eintrag kommentarlos und sieht wie ein Fehler aus.
    clock_in_discarded: "Ein- und Ausstempeln lagen in derselben Sekunde, es wurde nichts erfasst.",
    // Die Pause ist das Einzige, was die Stechuhr nicht wissen kann. Direkt nach dem Gehen
    // angeboten, statt einen Monat später in der Wochenliste gesucht.
    add_break_now: "Pause nachtragen",
    // Wird gefragt, bevor ein Tag beendet wird, der nicht heute begann: geschlossen wird der Tag des
    // Einstempelns, nicht heute. Aus einem vergessenen Freitag wird sonst unbemerkt ein Tag von
    // 60 Stunden — samt Verstoß gegen das Arbeitszeitgesetz.
    stale_clock_out_title: "Tag vom {date} beenden?",
    // Der Satz nennt nur, was von beiden Stellen aus gilt: auf „Meine Zeiten“ öffnet sich der Eintrag
    // danach von selbst, in der Kopfzeile führt die Meldung dorthin. Ein Versprechen, das der Chip
    // nicht halten kann, wäre in derselben Frage falsch.
    stale_clock_out_text:
      "Das Ausstempeln beendet den Tag vom {date}; daraus werden {duration} Std. am Stück. Das Ende lässt sich danach korrigieren.",
    // Nach dem Ausstempeln eines alten Tages. Auf „Meine Zeiten“ ohne Aktion, weil das Formular
    // bereits offen davor steht; in der Kopfzeile mit dem Weg dorthin, weil dort kein Formular
    // aufgeht.
    stale_clocked_out: "Der Tag vom {date} wurde beendet · {hours} Std. Bitte das Ende korrigieren.",
    // Beschriftung des dritten Symbols in der Zeile. Nennt den Tag, auf dem die Kopie landet, weil
    // die Regel dahinter — der nächste noch leere Tag der Woche — sonst erst im geöffneten Formular
    // sichtbar wird. Das Datum steht mit Wochentag da, wie überall sonst in der Liste.
    duplicate_to: "Als {date} duplizieren",
    // Ein laufender Tag hat kein Ende, und ohne Ende gibt es nichts zu kopieren. Anderer Grund als
    // beim Bleistift daneben, deshalb ein eigener Satz statt `running_not_editable`.
    running_not_duplicable: "Läuft noch, es gibt noch kein Ende zum Kopieren.",
    // Kein "tippen": dieselbe Meldung erscheint am Schreibtisch mit der Maus.
    running_not_editable: "Läuft noch, erst ausstempeln.",
    approved_not_editable: "Freigegeben, muss zuerst wieder geöffnet werden.",
    // Beschriftung der Kennzahlen über der Woche. "Ist" statt "Arbeitszeit", weil daneben Soll und
    // Saldo stehen.
    week_actual: "Ist",
    week_target: "Soll",
    week_balance: "Saldo",
    // Zählt Tage, nicht Einträge: ein Tag mit Vormittag auf der einen und Nachmittag auf der anderen
    // Baustelle ist ein erfasster Tag mit zwei Einträgen. Beides steht deshalb nebeneinander.
    week_days: "Erfasste Tage",
    week_entries: "{count} Einträge",
    // Unter dem Ist-Wert, neben dem Balken: wie viel der Woche geschafft ist.
    week_target_share: "{percent} % vom Soll",
    // Unter dem leeren Soll-Wert. Kurzform des Satzes, der unter dem Formular steht: auf einer
    // Kachel ist Platz für den Grund, nicht für die Erklärung.
    week_no_model: "Kein Arbeitszeitmodell",
    // Überschriften der Karten neben der Liste.
    week_chart: "Wochenverlauf",
    week_projects: "Projekte dieser Woche",
    // Statt die restlichen Projekte wegzulassen: eine auf neun Baustellen verteilte Woche sähe sonst
    // aus wie eine Woche auf fünf.
    week_projects_more: "{count} weitere · {hours} Std.",
    // Überschrift der Wochenliste. Sie stand vorher nicht da — die Karte begann mit der
    // Wochenauswahl, die inzwischen über der ganzen Seite steht.
    entries_title: "Erfasste Zeiten",
    // Beschriftung der anklickbaren Balken und Zeilen: was der Klick tut, nicht was dort steht. Wird
    // vorgelesen und steht sonst nirgends — die Auswahl ist sichtbar, ihre Bedienung nicht.
    filter_by_day: "Nur {day} anzeigen",
    filter_by_project: "Nur {project} anzeigen",
    filter_clear: "Filter aufheben",
    // Zwei verschiedene Aussagen: "diese Woche ist nichts erfasst" und "zu dieser Auswahl gibt es
    // nichts". Die Woche hat Tage, die Auswahl hat keine.
    filter_empty: "Kein Eintrag für diese Auswahl.",
    // Solange gefiltert wird, steht im Zähler beides — sonst liest er sich, als enthalte die Woche
    // nur das, was gerade zu sehen ist.
    filter_count: "{shown} von {total}",
    loading: "Zeiten werden geladen …",
  },
  clock: {
    idle_title: "Keine laufende Erfassung",
    // Nennt die Uhrzeit, mit der gestartet wird: die Schaltfläche fragt danach nicht nach.
    idle_hint: "Die Erfassung beginnt um {time} Uhr.",
    running_since: "seit {time} Uhr",
    // Nennt zusätzlich das Datum, sobald der offene Tag nicht mehr heute ist: „seit 7:12 Uhr“ liest
    // sich sonst wie heute Morgen, während die verstrichene Zeit daneben in Tagen zählt.
    running_since_date: "seit {date}, {time} Uhr",
    // Steht unter der Schaltfläche, bevor sie gedrückt wird: Ausstempeln beendet den Tag, von dem der
    // Eintrag stammt — die ganze Zeit seitdem landet auf diesem Datum, nicht auf heute.
    stale_running:
      "Du hast einen offenen Tag vom {date}. Das Ausstempeln beendet diesen Tag. Prüfe die Zeiten anschließend und korrigiere sie, falls du das Ausstempeln vergessen hast.",
    // Der Server lehnt jedes Einstempeln ab, und der offene Eintrag liegt außerhalb jedes Zeitraums,
    // den diese Seite abfragt. Nichts hier kann ihn schließen — deshalb wird es gesagt, statt eine
    // Schaltfläche stehen zu lassen, die bei jedem Tippen abgelehnt wird.
    unreachable_running:
      "Der Server meldet eine laufende Erfassung, die diese Seite nicht anzeigen kann: der offene Tag liegt zu weit zurück. Er steht auf der Anwesenheitstafel; wende dich an die Zeiterfassung deiner Firma, damit er geschlossen wird.",
    no_project: "Ohne Projekt",
    // Kein Fehler, aber der Moment, ihn zu beheben, ist heute — nicht bei der Nachkalkulation.
    no_project_running: "Kein Projekt zugeordnet",
    // Vorlesehilfe der großen Zahl. Sagt ausdrücklich, dass Pausen abgezogen sind: die Zahl stand
    // während einer Pause sonst still, ohne dass jemand wüsste, warum.
    elapsed: "Arbeitszeit bisher, erfasste Pausen abgezogen",
    // Der Grund, warum es diese Schaltfläche gibt: das Arbeitszeitmodell zieht die gesetzliche Pause
    // ab, ob jemand sie einträgt oder nicht. Ohne Stempel steht im Nachweis ein Abzug ohne Uhrzeiten.
    // Ein Wort, weil es neben „Ausstempeln" steht und nicht mit ihm verwechselt werden darf.
    break_start: "Pause",
    break_end: "Pause beenden",
    // Die Zeile unter der großen Zahl während der Pause. Die Pause zählt hier hoch, während die
    // Zahl darüber stillsteht: eine angehaltene Stoppuhr ohne mitlaufende Gegenzahl liest sich als
    // defekt und nicht als pausiert.
    on_break_since: "Pause läuft seit {time} Uhr · {duration}",
    // Chip neben den Schaltflächen, sobald der Tag bereits Pausenzeiten hat. Sagt vor dem Heimgehen,
    // dass der Nachweis diesmal Uhrzeiten enthält — die stille Nachfrage, die sonst niemand stellt.
    break_recorded: "Pause {duration} erfasst",
    // Die Beschriftung des Chips in der Kopfzeile während der Pause. Die Zahl im Chip zählt weiter:
    // sie ist die Anwesenheit und war es immer — gesagt wird das hier, weil im Chip kein Platz ist.
    chip_on_break: "Pause seit {time} Uhr, die Arbeitszeit steht still. Zu „Meine Zeiten“",
    // Beschriftung des Chips in der Kopfzeile. Nennt die Startzeit, weil die verstrichene Zeit im
    // Chip selbst steht — und sagt, wohin der Klick führt, weil ein Chip sonst wie eine reine
    // Anzeige aussieht.
    chip_open: "Erfassung läuft seit {time} Uhr. Zu „Meine Zeiten“",
    // Dieselbe Beschriftung mit Datum, sobald der offene Tag nicht heute begann: ohne das Datum
    // liest sich „seit 7:12 Uhr“ wie heute Morgen, während der Tag seit Wochen läuft.
    chip_open_date: "Erfassung läuft seit {date}, {time} Uhr. Zu „Meine Zeiten“",
    // Steht im Chip anstelle der laufenden Zahl, sobald der offene Tag nicht mehr heute ist. „312:45“
    // stimmt zwar, wird aber im Vorbeigehen nicht als „seit vorletzter Woche“ gelesen — und vor dem
    // Ausstempeln zählt, welchen Tag es beendet.
    chip_since_date: "seit {date}",
    // Aktion der Meldung, die dem Ausstempeln eines alten Tages folgt. Nennt das Ziel und nicht die
    // Aufgabe („Ende korrigieren“): getippt wird sie in irgendeiner Maske, und was danach passiert,
    // ist ein Seitenwechsel — kein Formular, das sich über die laufende Arbeit legt.
    chip_to_my_times: "Zu „Meine Zeiten“",
  },
  review: {
    // "Freigeben" allein sagt nicht, wozu die Seite dient — geprüft und korrigiert wird hier
    // genauso, und die Freigabe ist die Schaltfläche am Ende davon.
    title: "Zeiten prüfen",
    // Ohne "Erfasste Zeiten" am Anfang: das steht bereits in der Überschrift darüber. Die drei
    // Verben sind der eigentliche Inhalt — dass hier auch korrigiert wird, ist das, was die
    // Überschrift eben nicht sagt — und der Zusatz nennt, worauf das Freigeben hinausläuft.
    //
    // Ein zweiter Satz zählte eine Zeit lang die drei Ansichten daneben auf. Er ist wieder weg: die
    // Reiterleiste steht zwei Zeilen darunter und trägt genau diese drei Wörter selbst, sodass der
    // Satz dieselbe Auskunft ein zweites Mal gab — und dafür lief die Zeile bei 960 Pixeln auf drei
    // Zeilen um und drückte die Aktionen daneben. Was die Bereiche darunter sollen, sagt die
    // Erklärung, und zwar an jedem von ihnen.
    subtitle: "Prüfen, korrigieren und für die Lohnabrechnung freigeben.",
    // Ein Begriff für die Sache, und zwar der, der ohnehin schon unter dem Raster steht: „• fehlt".
    // Vorher gab es fünf - fehlt, ohne Erfassung, Keine Erfassung, Lücke, Tage ohne Erfassung -, und
    // wer im Raster ein Punktzeichen sah, suchte danach einen Filter, der anders hieß.
    //
    // Das „mit" gehört dazu: gefiltert werden *Mitarbeiter*, nicht Tage. Angehakt stehen die vollen
    // Zeilen derer da, die einen fehlenden Tag haben - samt allen erfassten.
    only_gaps: "Nur mit fehlenden Tagen",
    // Kein Mitarbeiter gewählt heißt: es wurde gar nicht gesucht. Vorher stand hier "nichts
    // erfasst", was eine Aussage über Daten ist, die nie abgefragt wurden.
    no_selection: "Bitte zuerst Mitarbeiter auswählen.",
    select_employees: "Mitarbeiter",
    // Alle-auswählen sitzt im Auswahlmenü selbst — wie beim Projektfilter in der Kostenübersicht.
    select_all_employees: "Alle auswählen",
    clear_all_employees: "Auswahl löschen",
    employees_count: "{selected} von {total} Mitarbeitern ausgewählt",
    // Solange eine Suche die Liste einengt, ist "von {total}" eine Aussage über eine Gesamtzahl, die
    // gerade nicht dasteht — "5 von 3 ausgewählt" liest sich als Fehler. Dann wird nur gezählt.
    employees_count_selected: "{selected} ausgewählt",
    // Über einem Suchergebnis heißt "alle" nicht alle: die Schaltfläche wählt, was dasteht, und sagt
    // das auch. Alles Passende serverseitig zu ticken hieße, Namen auszuwählen, die dieses Feld nie
    // gezeigt hat — und die Freigabe danach beträfe Leute, die niemand gesehen hat.
    select_all_shown: "Alle {count} angezeigten auswählen",
    // Woher die Auswahl kommt, nicht wie die Funktion heißt. Die Seite öffnet sonst mit allen, also
    // ist ein Gedächtnis das Einzige, was einen unbeschriebenen Aufruf einschränkt — und darüber steht
    // schon "2 von 19 Mitarbeitern ausgewählt". Offen bleibt nur: wer hat die 2 gewählt?
    // Hieß "Gemerkte Auswahl": eine Beschriftung für die Funktion, keine Antwort auf die Frage.
    remembered: "Auswahl vom letzten Besuch",
    // Beschriftung des Statusfilters. Bewusst dasselbe Wort wie über der Spalte, die er filtert —
    // ein zweiter Begriff für dieselbe Sache wäre ein zweiter Begriff zum Lernen.
    filter_status: "Status",
    // Beschriftung des Projektfilters, nach derselben Regel wie oben: dasselbe Wort wie über der
    // Spalte, die er filtert. Die Auswahl "Ohne Projekt" steht darin gleichberechtigt neben den
    // Projekten und heißt dort, wie sie im Rest der Zeiterfassung heißt (`clock.no_project`) —
    // deshalb braucht sie hier keinen eigenen Schlüssel.
    filter_project: "Projekt",
    approve: "Freigeben",
    reject: "Ablehnen",
    // Bewusst nicht "Bearbeiten": eine freigegebene Zeit wird nicht still geändert, sondern zuerst
    // wieder geöffnet — das ist der Vorgang, den jemand bewusst auslösen soll.
    reopen: "Wieder öffnen",
    // Zwei Rollen, zwei Schlüssel. Der Dialogtitel darf den Satz ausschreiben: er hat die Breite
    // für sich und erscheint erst nach dem Klick. Die Schaltfläche steht neben "Export" in der
    // Kopfzeile und muss kurz sein.
    //
    // "Sammelerfassung" ist dabei kein neues Wort, sondern genau das, was die Spalte
    // "Erfassungsart" für diese Zeilen anzeigt (`source.CREW`). Vorher hieß dieselbe Sache auf
    // demselben Bildschirm zweimal verschieden: die Schaltfläche erzeugte etwas, das die Tabelle
    // daneben anders nannte.
    //
    // Nicht "fürs Team": der Polier erfasst den Tag für mehrere namentlich gewählte Leute, und
    // "Team" ist im Produkt bereits ein eigener Begriff (Trupp).
    crew_action: "Sammelerfassung",
    // Das zweite Werkzeug für eine leere Zelle: nicht jede Lücke ist eine vergessene Erfassung, manche
    // ist Urlaub, den niemand eingetragen hat. Dasselbe Wort wie in der Personalplanung, weil es dieselbe
    // Sache ist und dort auch erscheint.
    absence_action: "Abwesenheit",
    absence_entry: "Abwesenheit für einen oder mehrere Mitarbeiter eintragen",
    absence_saved: "Abwesenheit eingetragen. | {count} Abwesenheiten eingetragen.",
    // Was nicht eingetragen oder ersetzt wurde, beim Namen genannt: vorher wurde es still übersprungen.
    absence_skipped: "Übersprungen: {days}.",
    absence_replaced: "Ersetzt: {days}.",
    absence_removed: "Abwesenheit entfernt.",
    absence_remove_title: "Abwesenheit entfernen?",
    // Entfernt wird nur der geklickte Tag. Der Satz nennt, was von der Abwesenheit bleibt, und dass die
    // Personalplanung es auch verliert: es ist derselbe Eintrag.
    absence_remove_text:
      "{absence} für {name} am {date} wird entfernt, auch in der Personalplanung. Der Rest vom {from} bis {to} bleibt.",
    absence_remove_text_single: "{absence} für {name} am {date} wird entfernt, auch in der Personalplanung.",
    // Der Knopf im Dialog einer leeren Zelle. "Hier" ist wörtlich gemeint: Person und Tag stehen
    // schon fest, der Dialog öffnet sie ausgefüllt.
    create_here: "Zeit hier erfassen",
    // Derselbe Dialog, aber für genau einen Namen: "für mehrere Mitarbeiter" und "für alle" wären
    // über einem Formular mit einem Namen zwei Sätze, die in dem Moment nicht stimmen - und es sind
    // die zwei, die man vor dem Drücken liest. Sie folgen deshalb dem Feld, nicht dem Einstieg.
    crew_entry_one: "Zeit erfassen",
    crew_submit_one: "Erfassen",
    crew_entry: "Zeiten für mehrere Mitarbeiter erfassen",
    crew_submit: "Für alle erfassen",
    // Spaltenköpfe. Vorher stand über der Quellenspalte "Selbst erfasst" — also ein Wert als
    // Überschrift — und über der Statusspalte gar nichts.
    column_source: "Erfassungsart",
    // Steht unter den Uhrzeiten des Tages, sobald ein Pausenabzug ohne erfasste Pausenzeiten
    // dasteht. Die Stunden stimmen — der Beleg fehlt, und die Freigabe ist der letzte Moment, ihn
    // einzufordern. Nennt die abgezogene Dauer, weil genau die im Nachweis ohne Uhrzeit dasteht.
    break_undocumented: "Pause {duration} nicht dokumentiert",
    break_undocumented_hint:
      "Für diesen Tag ist keine Pausenzeit erfasst. Der gesetzliche Mindestabzug wurde angerechnet, " +
      "Beginn und Ende der Pause fehlen im Nachweis (§ 16 Abs. 2 ArbZG).",
    column_status: "Status",
    total: "Summe",
    // Der Server lehnt die ganze Freigabe ab, wenn ein laufender Tag dabei ist, und begründet das
    // mit "Ende liegt nicht nach dem Beginn" — was hier nichts erklärt. Also vorher sagen.
    approve_running_blocked: "Ein noch laufender Tag kann nicht freigegeben werden.",
    // Der Monatsabschluss besteht genau aus dieser einen Handlung: alles, was im Zeitraum offen ist,
    // für die gewählten Leute freigeben. Zwei Rollen, zwei Schlüssel — wie bei der Sammelerfassung:
    // die Schaltfläche steht neben "Export" und muss kurz sein, der Dialogtitel darf den Satz
    // ausschreiben und tut es auch, weil er die Frage stellt, die man nur einmal falsch beantworten
    // muss.
    approve_period: "Zeitraum freigeben",
    approve_period_hint:
      "Alle noch offenen Zeiten der gewählten Mitarbeiter im Zeitraum freigeben, auch die, die der Filter gerade ausblendet.",
    // Kein "nichts wartet auf Freigabe", solange niemand ausgewählt ist: dafür gibt es
    // `no_selection`. Eine Aussage über Daten, die nie abgefragt wurden, ist keine Antwort.
    approve_period_none: "Im gewählten Zeitraum wartet keine Zeit auf Freigabe.",
    approve_period_title: "Alles im Zeitraum freigeben?",
    // Nennt den Umfang, den die Schaltfläche selbst nicht nennen kann: welcher Zeitraum, wie viele
    // Leute, wie viele Zeiten. Der Nachsatz ist der Grund, warum es diesen Dialog gibt — genau hier
    // greift eine Freigabe über das hinaus, was auf dem Bildschirm steht.
    approve_period_text:
      "{count} Zeiten von {people} Mitarbeitern im Zeitraum {from} – {to} werden freigegeben, unabhängig davon, was die Filter gerade anzeigen.",
    // Was "alles" auslässt, und warum. Ein "alles", das stillschweigend "alles außer den vier noch
    // laufenden" heißt, fällt erst nach der Lohnabrechnung auf.
    approve_period_skipped_running:
      "{count} noch laufende Zeiten bleiben offen: ein Tag ohne Ende kann nicht freigegeben werden.",
    approve_period_skipped_approved:
      "{count} bereits freigegebene Zeiten bleiben unverändert. Wer sie freigegeben hat, bleibt so nachvollziehbar.",
    // Die eigenen Zeiten des Prüfenden. Nicht "gesperrt": sie warten weiter, nur auf jemand anderen.
    approve_period_skipped_own: "{count} selbst erfasste Zeiten bleiben offen: sie gibt eine andere Person frei.",
    // Statt "Im Zeitraum wartet nichts" — das wäre falsch, es warten ja Zeiten, nur nicht auf diese Person.
    approve_period_only_own: "Im Zeitraum warten nur selbst erfasste Zeiten. Die gibt eine andere Person frei.",
    // Grund, warum eine selbst erfasste Zeile keine Freigabe anbietet und nicht ausgewählt werden kann —
    // die eigene, oder eine, die man per Sammelerfassung für jemand anderen eingetragen hat. Sagt, wer
    // es stattdessen tut, statt nur "nicht erlaubt".
    self_review_blocked: "Zeiten, die Sie selbst erfasst haben, gibt eine andere Person frei.",
    edit: "Zeit bearbeiten",
    delete: "Zeit löschen",
    delete_title: "Zeit löschen?",
    delete_text: "Der Eintrag von {name} vom {date} wird gelöscht. Das lässt sich nicht rückgängig machen.",
    deleted: "Zeit gelöscht.",
    saved: "Zeit gespeichert.",
    approved: "{count} Zeiten freigegeben.",
    rejected: "{count} Zeiten abgelehnt.",
    reopened: "{count} Zeiten wieder geöffnet.",
    loading: "Zeiten werden geladen …",
    // Wer den Status gesetzt hat und wann — unter dem Chip, der sagt, *welchen*. Bewusst neutral
    // formuliert: "Freigegeben von …" unter einem roten "Abgelehnt" widerspräche dem Chip darüber,
    // und das Urteil steht dort bereits.
    reviewed_by: "Geprüft von {name} · {at}",
    // Derselbe Satz ohne Namen. Kommt praktisch nicht vor — der Server stempelt beides zusammen —,
    // aber ein Zeitpunkt ohne Namen ist immer noch mehr als eine leere Zeile.
    reviewed_at: "Geprüft am {at}",
    // Wer den Tag getippt hat, wenn das nicht der Mitarbeiter selbst war: bei der Sammelerfassung
    // der Polier, beim Import derjenige, der ihn angestoßen hat. "Sammelerfassung" allein sagt nur,
    // *dass* es jemand anderes war — und genau daran hängt ein strittiger Bautag.
    recorded_by: "Erfasst von {name}",
    // Wo der Tag erfasst wurde — im `title` unter dem Erfassungsart-Chip. Zwei Zeilen, wenn ein laufender
    // Tag auf einem anderen Gerät beendet wurde (auf der Baustelle gekommen, im Büro gegangen).
    captured_via: "Erfasst über {channel} · {at}",
    clocked_out_via: "Beendet über {channel} · {at}",
    // Der Hinweis am Kartensymbol. Nennt, welcher Standort und wie genau — nie die Koordinaten selbst.
    capture_location: "Standort beim {kind} auf der Karte öffnen",
    capture_location_accuracy: "Standort beim {kind} auf der Karte öffnen · ±{accuracy} m",
    capture_kind_in: "Erfassen",
    capture_kind_out: "Beenden",
    // Unter der Zeile oben, wenn die App einen Stempel ohne Verbindung behalten und später gesendet hat:
    // die Uhr des Handys beim Tippen und die des Servers beim Eingang. Mit Datum, wo die Tage verschieden sind.
    stamped_late: "Gestempelt {stamped}, übertragen {received}",
    // Dass die App keinen Standort mitschicken konnte, weil das Handy keinen fand. Dass ihn jemand nicht
    // erlaubt oder ausgeschaltet hat, speichert der Server nicht.
    location_missing: {
      UNAVAILABLE: "Kein Standort gefunden",
    },
    // Der Grund zur Ablehnung. Vorher gab es keinen: die Zeile wurde rot, der Mitarbeiter erfuhr
    // nichts, und der einzige Weg weiter war nachfragen. Genau so hört jemand auf zu erfassen.
    note_label: "Begründung",
    note_optional: "Optional",
    note_required: "Bitte geben Sie einen Grund an.",
    note_placeholder_reject: "Was stimmt an diesem Tag nicht?",
    note_title_approve: "Zeiten freigeben",
    note_title_reject: "Zeiten ablehnen",
    note_title_reopen: "Zeiten wieder öffnen",
    note_prompt_approve: "{count} Zeiten werden für die Lohnabrechnung freigegeben. Ein Vermerk ist optional.",
    // Nur hier ist der Satz Pflicht: eine Ablehnung ohne Grund ist keine Entscheidung, sondern eine Hürde.
    // Vorher stand hier „erscheint beim Mitarbeiter am Tag“ — das las sich wie eine Uhrzeit. Genannt
    // wird deshalb der Ort, an dem er ihn tatsächlich findet: seine eigene Wochenliste unter „Meine
    // Zeiten“. Und dass der Grund beim Korrigieren verfällt, denn das entscheidet, was hier zu tippen
    // ist: eine Anweisung für diesen einen Tag, kein Aktenvermerk, der stehen bleibt.
    note_prompt_reject:
      "{count} Zeiten werden abgelehnt. Der Mitarbeiter sieht den Grund unter „Meine Zeiten“ am abgelehnten Tag; er verschwindet, sobald der Tag korrigiert wird.",
    note_prompt_reopen: "{count} bereits freigegebene Zeiten werden wieder geöffnet. Ein Vermerk ist optional.",
  },
  coverage: {
    // Die Zahl, wegen der jemand hinschaut. Steht in der Kopfzeile, weil das Raster über drei Monate
    // höher ist als der Bildschirm.
    missing_count: "{count} fehlender Tag | {count} fehlende Tage",
    complete: "Vollständig erfasst",
    // Der Grund für die vorsichtige Wortwahl: Feiertage kennt das Produkt nicht. Ein 24. Dezember
    // ohne eingetragene Abwesenheit steht deshalb als Lücke im Raster.
    note: "Feiertage sind nicht hinterlegt. Sie erscheinen als fehlende Tage, sofern keine Abwesenheit eingetragen ist.",
    // Halber Urlaubstag: erklärt einen kurzen Tag, aber keinen leeren.
    partial_absence: "{absence} (halber Tag)",
    state: {
      RECORDED: "Erfasst",
      RUNNING: "Läuft",
      // Bewusst nicht "vergessen" oder "fehlt": das Raster weiß nicht, ob der Tag ein Feiertag war.
      MISSING: "Fehlt",
      ABSENT: "Abwesend",
      OFF: "Kein Arbeitstag",
      NO_MODEL: "Kein Arbeitszeitmodell",
      // Heute Nachmittag und morgen sind keine Versäumnisse.
      FUTURE: "Noch offen",
    },
  },
  form: {
    date: "Datum",
    period_from: "Von",
    period_to: "Bis",
    from_time: "Beginn",
    to_time: "Ende",
    breaks: "Pausen",
    add_break: "Pause hinzufügen",
    project: "Projekt",
    shift: "Schicht",
    note: "Notiz",
    employees: "Mitarbeiter",
    // Spaltenkopf über einer Monatsspalte — im Arbeitszeitkonto und im Monatsverlauf auf "Meine
    // Zeiten". Stand bis zur Entfernung der Auswertung in deren Schlüsselraum, wo es nach ihr
    // niemandem mehr gehört hätte.
    month: "Monat",
    // Wer den Tag eingetragen hat — nicht zwingend derjenige, dessen Tag es ist: Der Polier erfasst
    // für seine Kolonne. Steht nur im Aktivitätsprotokoll, das Formular fragt das nicht ab.
    recorded_by: "Erfasst von",
    // Beschriftungen im Aktivitätsprotokoll. Der Standort selbst steht dort bewusst nie.
    capture_channel: "Erfasst über",
    captured_at: "Erfasst am",
    clock_out_channel: "Beendet über",
    clocked_out_at: "Beendet am",
    stamped_at: "Gestempelt am (Handy)",
    location_missing: "Standort",
    clock_out_stamped_at: "Beendet am (Handy)",
    clock_out_location_missing: "Standort beim Beenden",
    reviewed_at: "Geprüft am",
    reviewed_by: "Geprüft von",
    // Steht neben dem vorbelegten Projekt und sagt, woher der Vorschlag kommt — sonst wirkt er wie
    // eine unerklärte Voreinstellung, die niemand zu ändern wagt.
    suggested_from_planning: "Aus der Personalplanung",
    // Ohne "dieses Mitarbeiters": auf "Meine Zeiten" ist der Mitarbeiter der Lesende selbst.
    suggested_from_membership: "Einziges zugeordnetes Projekt",
    // In der Sammelerfassung erfasst jemand für andere — hier muss dazustehen, wessen Projekt
    // gemeint ist.
    suggested_from_membership_crew: "Einziges Projekt der Ausgewählten",
    // Steht statt einer Vorbelegung da: Die Ausgewählten sind an diesem Tag verschieden geplant.
    // Eines der Projekte stillschweigend zu nehmen hieße, acht Tage auf die falsche Baustelle zu
    // buchen — und niemand würde es merken, bis jemand die Nachkalkulation liest.
    suggested_mixed: "Die Ausgewählten sind an diesem Tag unterschiedlich geplant. Bitte Projekt wählen.",
    // Ab einer gewissen Kolonnengröße wird gar nicht erst gefragt (siehe LewTimeEntryCrewDialog).
    // Dass kein Vorschlag kommt, muss dastehen: ein stillschweigend leeres Feld sieht aus wie
    // "keine Planung vorhanden" und nicht wie "nicht gefragt".
    suggested_too_many: "Zu viele Ausgewählte für einen Projektvorschlag. Bitte Projekt wählen.",
    // Über den Zahlen der Sammelerfassung. Sie messen einen Tag, den mehrere gemeinsam haben — das
    // Arbeitszeitmodell dahinter haben sie nicht zwingend gemeinsam. Deshalb steht in jedem Fall
    // dabei, für wen sie gelten: Soll und gesetzlicher Pausenabzug aus dem Modell eines Einzelnen
    // wären für die übrigen sieben schlicht falsch, und zwar unbemerkt.
    crew_figures_shared: "Berechnet nach „{model}“, dem Arbeitszeitmodell aller Ausgewählten.",
    crew_figures_mixed:
      "Die Ausgewählten arbeiten nach verschiedenen Arbeitszeitmodellen. Unten steht nur die erfasste Zeit; Pausenabzug und Soll rechnet der Server für jeden einzeln.",
    crew_figures_none:
      "Keiner der Ausgewählten hat an diesem Tag ein Arbeitszeitmodell, daher kein Soll und kein gesetzlicher Pausenabzug.",
    crew_figures_not_asked:
      "Bei mehr als {max} Ausgewählten wird das Arbeitszeitmodell nicht geprüft. Unten steht nur die erfasste Zeit; Pausenabzug und Soll rechnet der Server für jeden einzeln.",
    crew_figures_unknown:
      "Arbeitszeitmodell der Ausgewählten nicht bekannt. Unten steht nur die erfasste Zeit; Pausenabzug und Soll rechnet der Server für jeden einzeln.",
    // Das Projekt ist überall freiwillig — Einstempeln, Formular und Sammelerfassung nehmen alle
    // einen Eintrag ohne Projekt an. Im Feldnamen gesagt und nirgends sonst: ein erklärender Satz
    // unter dem Feld stand bei jedem Blick auf die Seite da, für den Normalfall.
    project_optional: "Projekt (optional)",
    // Die Schicht ist genauso freiwillig wie das Projekt: kein Feld der Schnittstelle verlangt sie,
    // das Einstempeln legt Tage ganz ohne an, und keine Prüfung im Backend sieht sie an. Neben
    // "Projekt (optional)" las sich das schmucklose "Schicht" trotzdem wie eine Pflichtangabe —
    // also dieselbe Klammer und nicht eine zweite Redeweise für dieselbe Aussage.
    // Eigener Schlüssel, weil [shift] daneben als bloßes Wort weiterlebt: das
    // Aktivitätsprotokoll setzt es vor "Beginn" und "Ende" zusammen, und dort wäre die Klammer
    // Unsinn.
    shift_optional: "Schicht (optional)",
    shift_hint: "Übernimmt die Zeiten der Schicht.",
    // Überschrift und Schaltfläche des Formulars, getrennt vom Menüpunkt "Zeit erfassen": beim
    // Korrigieren eines Tages stand vorher "Zeit erfassen" über dem Formular und "Hinzufügen"
    // darunter — beides falsch.
    title_create: "Zeit erfassen",
    title_edit: "Zeit bearbeiten",
    submit_create: "Erfassen",
    minutes: "{minutes} Min.",
    remove_break: "Pause entfernen",
    // Die gesetzliche Pause wird ohnehin abgezogen. Wer das nicht weiß, wundert sich über eine
    // halbe Stunde, die er nie eingetragen hat.
    no_breaks: "Keine Pause erfasst. Die gesetzliche Pause wird trotzdem abgezogen.",
    // Im Formular gesagt, statt nach dem Speichern als Serverfehler — und bewusst anders formuliert
    // als die Servermeldung (violation.timetracking.invalid_time_range), damit erkennbar bleibt,
    // welche der beiden Prüfungen angeschlagen hat.
    end_after_start: "Beginn und Ende sind identisch, daraus ergibt sich keine Arbeitszeit.",
  },
  figures: {
    // Substantive, weil sie als Spaltenköpfe neben "Pause" und "Arbeitszeit" stehen.
    gross: "Anwesenheit",
    break: "Pause",
    worked: "Arbeitszeit",
    target: "Soll",
    balance: "Saldo",
    // Erscheint, wenn für den Tag überhaupt keine Pausenzeit eingetragen ist. Warnfarbe statt
    // Kleingedrucktem: der Abzug ist richtig, der Beleg dafür fehlt. Nach § 16 Abs. 2 ArbZG muss der
    // Nachweis sagen können, wann die Pause war — „eine halbe Stunde, irgendwann" ist keine Antwort.
    // Der Satz nennt deshalb die Abhilfe, und die steht in der Zeile direkt über diesen Zahlen.
    break_undocumented:
      "Keine Pausenzeit erfasst, der gesetzliche Mindestabzug wurde trotzdem angerechnet. " +
      "Trage oben ein, wann die Pause war.",
    // Derselbe Sachverhalt, aber für den, der sehr wohl eine Pause eingetragen hat und in den Zahlen
    // nichts davon wiederfindet: 15 Minuten an einem Tag, der 30 verlangt, ändern nichts. Ohne
    // diesen Satz — und ohne die erfasste Summe unter dem Pausenwert — liest sich das als
    // "meine Eingabe wurde verworfen". Die beiden Sätze schließen einander aus.
    statutory_break_absorbed: "Die erfasste Pause ist kürzer als die gesetzliche. Abgezogen wird die längere.",
    // Steht klein unter dem Pausenwert, sobald mehr abgezogen wird als erfasst wurde. Ohne Einheit,
    // wie die Werte darüber.
    break_recorded: "{recorded} erfasst",
    no_model: "Kein Arbeitszeitmodell zugewiesen, daher kein Soll.",
    // Steht neben den Zahlen, sobald die Arbeitszeit über der Höchstarbeitszeit des Modells liegt —
    // also während getippt wird, nicht erst wenn der Server ablehnt.
    //
    // Eigener Schlüssel statt `violation.timetracking.exceeds_daily_maximum`, obwohl es dieselbe
    // Regel ist, und zwar aus zwei Gründen. Der Satz dort ist die Begründung einer Absage und nennt
    // keine Zahl; hier steht die Arbeitszeit eine Zeile darüber, und die einzige offene Frage lautet
    // „über welcher Grenze?" — die Grenze im selben H:MM-Format wie die Werte daneben ist die
    // Antwort, und der Satz dort kann sie nicht tragen, weil er keinen Parameter hat. Und wortgleich
    // wäre schlimmer als doppelt: wer den Satz schon gelesen und trotzdem gespeichert hat, sieht ihn
    // danach als Meldung des Servers gar nicht mehr — dass sich etwas geändert hat, sagt erst der
    // andere Ton.
    exceeds_daily_maximum:
      "Über der Höchstarbeitszeit von {max}, die das Arbeitszeitmodell zulässt. So nimmt der Server den Tag nicht an.",
    // Einheit hinter allen Stundenwerten. Als Schlüssel, weil "h" im Deutschen ungebräuchlich ist.
    hours_unit: "Std.",
  },
  // ---------------------------------------------------------------------------------------------
  // Die drei Ansichten neben den erfassten Zeiten: Anwesenheit, Wochenraster, fehlende Zeiten.
  //
  // Sie waren einmal eine eigene Seite namens "Mitarbeiter" und sind jetzt Reiter in "Zeiten
  // prüfen". Deren Titel und Untertitel stehen deshalb nicht mehr hier — eine Überschrift für eine
  // Seite, die es nicht gibt, wird beim nächsten Lesen für eine vergessene Verwendung gehalten. Der
  // Schlüsselraum heißt weiterhin `team`: ihn umzubenennen bringt niemandem etwas, der die
  // Beschriftungen liest.
  team: {
    attendance_title: "Gerade eingestempelt",
    // Bewusst ohne Zeitraum: eine Tafel, die "die heutigen offenen Erfassungen" zeigt, verbirgt
    // genau den vergessenen Freitag, dessentwegen man sie aufruft.
    on_the_clock: "{count} eingestempelt",
    nobody_clocked_in: "Im Moment ist niemand eingestempelt.",
    unknown_employee: "Unbekannter Mitarbeiter",
    since: "seit {time} Uhr, {date}",
    // Steht in der Zeile der Tafel, nicht in der Zahl rechts: die zählt die Anwesenheit und läuft
    // durch die Pause hindurch, genau wie der Chip in der Kopfleiste.
    on_break_since: "in Pause seit {time} Uhr",
    // Tooltip der Zahl rechts. Sie zählt die Anwesenheit und läuft durch die Pause weiter, während
    // die Uhr auf „Meine Zeiten" die Arbeitszeit zeigt und dort stehen bleibt.
    attendance_hint: "Anwesenheit, Pause eingerechnet",
    today: "heute",
    // Keine Anklage: fast immer wurde schlicht das Gehen vergessen — und bis es nachgeholt ist,
    // kann derjenige keinen neuen Tag beginnen.
    forgotten_clock_out: "Ausstempeln vergessen?",
    // Steht im zugeklappten Banner. Ohne diese Zahl verbirgt das Zuklappen genau den Eintrag,
    // dessentwegen die Tafel existiert.
    stale_count: "{count} nicht ausgestempelt",
    // Während des Aktualisierens, neben dem Knopf. Der Aufruf dauert rund zwanzig Millisekunden -
    // ein Spinner allein war ein Zustand, den niemand sieht.
    refreshing: "Wird aktualisiert …",
    // Danach, und das ist der bleibende Teil: eine Animation ist nach einer halben Sekunde vorbei,
    // die Frage eine Minute später lautet "wie alt ist das hier".
    updated_at: "Stand {time}",
    refresh: "Aktualisieren",
  },

  // ---------------------------------------------------------------------------------------------
  // Arbeitszeitkonto.
  // ---------------------------------------------------------------------------------------------
  // Konto & Verstöße: die zwei Lesarten der erfassten Stunden, die niemand bearbeitet.

  account: {
    // Bezahlte Abwesenheiten, dem Konto gutgeschrieben.
    credit: "Gutschrift",
    title: "Arbeitszeitkonto",
    // Überschrift über der einen Zahl, wegen der jemand die Zeile öffnet.
    closing_at: "Stand am {date}",
    carry_over: "Übertrag",
    closing: "Stand",
    print_failed: "Der Monatsnachweis konnte nicht erzeugt werden.",
    // Der Grund steht am deaktivierten Knopf, statt ihn verschwinden zu lassen: der Export ist zu
    // finden, bevor die Filter stimmen.
    export_hint: "Mindestens einen Mitarbeiter wählen. Exportiert wird genau das, was die Filter beschreiben.",
    // Ohne Anfangswert beginnt das Konto beim ersten hier erfassten Tag — das ist etwas anderes
    // als "null Überstunden".
    no_opening: "Ohne Anfangssaldo",
    // Im Exportmenü der Seite, seit das Konto keinen eigenen Knopf mehr hat.
    export: "Arbeitszeitkonto als CSV",
    export_hint_short: "Übertrag, Saldo und Stand je Mitarbeiter",
    your_balance: "Ihr Arbeitszeitkonto:",
    as_of: "Stand {date}",
    // Aufklappen der Monate unter dem eigenen Stand. Substantiv statt "Monate anzeigen": der Pfeil
    // daneben sagt bereits, in welche Richtung die Schaltfläche gerade wirkt.
    months: "Monatsverlauf",
    // Wer diesen Monat angefangen hat, hat noch keinen abgeschlossenen. Der Satz sagt das, statt
    // eine leere Tabelle unter ihren Überschriften stehen zu lassen.
    no_months: "Für dieses Jahr ist noch kein Monat erfasst.",

    opening_title: "Anfangssaldo Arbeitszeitkonto",
    // Der zweite Halbsatz verhindert die doppelte Zählung und muss bleiben.
    opening_hint: "Überstunden zum Stichtag, z. B. aus dem alten System. Tage davor zählen nicht erneut.",
    opening_balance: "Anfangssaldo",
    opening_date: "Stichtag",
    // Die Zeile unter den Arbeitszeitmodellen des Mitarbeiters, die den Dialog öffnet. Der Saldo steht
    // wie im Arbeitszeitkonto („+12:30“), damit beide Stellen dieselbe Zahl zeigen.
    opening_line: "Anfangssaldo {balance} Std. zum {date}",
    opening_add: "Anfangssaldo eintragen",
  },

  // ---------------------------------------------------------------------------------------------
  // Arbeitszeitgesetz.
  compliance: {
    title: "Arbeitszeit-Verstöße",
    violations: "Verstöße",
    warnings: "Hinweise",
    rule: {
      DAILY_MAXIMUM_EXCEEDED: "Tageshöchstarbeitszeit",
      REST_PERIOD_TOO_SHORT: "Ruhezeit",
      BREAK_TOO_SHORT: "Pause zu kurz",
      BREAK_NOT_DOCUMENTED: "Pause nicht dokumentiert",
      WEEKLY_MAXIMUM_EXCEEDED: "Wochenarbeitszeit",
      OPEN_ENTRY_STALE: "Erfassung läuft noch",
    },
  },

  // ---------------------------------------------------------------------------------------------
  // Die Matrix: Mitarbeiter mal Tage, mit vier Lesarten.
  matrix: {
    mode: {
      // Die Reihenfolge des Schalters ist ein Ablauf: was gearbeitet wurde, was das offen lässt, wie
      // weit es gekommen ist, und was gegen eine Regel verstieß.
      worked: "Arbeitszeit",
      balance: "Saldo",
      status: "Status",
      violations: "Verstöße",
    },
    // Benennt die zwei Filter, die es meint. Hieß "folgen nicht den Filtern" - zu breit: das Konto
    // wird mit der Mitarbeiterauswahl und dem Zeitraum geladen und folgt beiden sehr wohl. Nur Status
    // und Projekt schränken die Zellen ein, ohne das Konto einzuschränken, und nur dann steht der Satz
    // überhaupt da.
    account_hint: "Übertrag und Stand folgen dem Status- und Projektfilter nicht.",
    // Die gute Nachricht, ausgesprochen. Vorher stand hier "Bitte zuerst Mitarbeiter auswählen",
    // obwohl alle ausgewählt waren — das beste Ergebnis der Prüfung als Bedienfehler.
    // Überschrift der rechten Spalte im Zelldialog: wer den Tag erfasst und wer ihn geprüft hat.
    // Eine andere Frage als die linke Spalte, gestellt zu einem anderen Zeitpunkt - meist Monate
    // später, wenn nicht der Zustand zählt, sondern wer ihn gesetzt hat.
    trail: "Nachweis",
    // Die Reichweite eines Urteils - einmal über den drei Knöpfen statt als Unterzeile an jedem.
    // Dreimal derselbe Satz ist nicht dreimal so klar, und er war es, der den Block im Zeilendialog
    // so hoch machte wie das Konto darüber.
    //
    // Sagt nur die Zahl, nicht den Bereich: die Überschrift darüber nennt ihn bereits, und zwar je
    // Dialog einen anderen - "Stefan Bergmann, 01.07.-21.09." in der Zeile, "Alle am 15.09.2026" in
    // der Spalte. Ein angehängtes "im Zeitraum" war in der Spalte schlicht falsch, die ist ein Tag.
    verdict_scope: "Wirkt auf {count} Zeiten",
    no_gaps: "Keine fehlenden Tage in diesem Zeitraum.",
    no_gaps_hint: "Für alle {count} ausgewählten Mitarbeiter ist jeder erwartete Tag erfasst.",
    show_all: "Alle Mitarbeiter zeigen",
    // Zwei Zahlen, weil sie auseinandergehen dürfen: markiert ist, was leuchtet, betroffen ist, was
    // ein Urteil wirklich ändert. Ein Block über eine Woche deckt freigegebene und eigene Tage mit ab.
    // Gebeugt, weil beide bei eins anfangen - die Aufrufstelle gibt die Zahl als Wahl mit.
    picked_cells: "{count} Zelle markiert | {count} Zellen markiert",
    picked_entries: "{count} Zeit betroffen | {count} Zeiten betroffen",
    picked_clear: "Auswahl aufheben",
    // Wirkt auf die markierten Tage, nicht auf die Zeiten darin: eine Abwesenheit braucht keinen Eintrag,
    // um eingetragen zu werden, und ein markierter leerer Tag ist genau der Fall, für den es sie gibt.
    picked_absence: "Abwesenheit eintragen",
    // Nur, wenn etwas verborgen ist. Die Zahlen in den Filtermenüs zählen den ganzen Zeitraum, nicht
    // die aktuelle Einschränkung — diese Zeile ist das, was den Unterschied sichtbar macht.
    shown: "{shown} von {loaded} Zeiten sichtbar",
    // Steht rechts über der Matrix und sagt, wie die Zellen gerade zu lesen sind. Kein Tooltip: eine
    // Legende gehört neben das, was sie erklärt, nicht hinter einen Hover.
    legend: {
      worked: "Zelle: erfasste Stunden · • fehlt · Kürzel abwesend · ▸ läuft",
      balance: "Zelle: Saldo gegen das Soll · grün darüber, amber darunter",
      status: "Zelle: E erfasst · F freigegeben · A abgelehnt · L läuft",
      violations: "Zelle: § Verstoß gegen das Arbeitszeitgesetz",
    },
    // Kürzel in der Statuszelle. Ein Buchstabe, weil in 56 Pixeln kein Wort steht; das ganze Wort
    // steht im Tooltip und im Tagesfenster.
    status_short: {
      OPEN: "L",
      SUBMITTED: "E",
      APPROVED: "F",
      REJECTED: "A",
    },
    // Was in einer leeren Zelle steht, je nachdem warum sie leer ist. Kurz gehalten: der Tooltip
    // erklärt eine Zelle, die nichts sagt, und ein Satz über einem leeren Feld liest sich länger,
    // als die Auskunft wert ist.
    empty: {
      MISSING: "Arbeitstag ohne Erfassung",
      ABSENT: "Abwesend",
      OFF: "Kein Arbeitstag",
      NO_MODEL: "Kein Arbeitszeitmodell",
      FUTURE: "Noch in der Zukunft",
      RECORDED: "Erfasst",
      RUNNING: "Läuft noch",
    },
    day_actions: "Tag beurteilen",
    employee_actions: "Konto und Freigabe",
    // Der farbige Punkt in der Ecke einer Zelle, deren Tag nur zum Teil abwesend war.
    absence_partial: "{name}, halber Tag",
    scope_day: "Alle am {date}",
    nothing_to_approve: "Hier wartet nichts auf eine Entscheidung.",
  },

  // ---------------------------------------------------------------------------------------------
  // Abwesenheiten, eingetragen in "Zeiten prüfen". Gespeichert als derselbe Eintrag, den die
  // Personalplanung schreibt, deshalb dieselben Wörter.
  absence: {
    title: "Abwesenheit eintragen",
    kind: "Art der Abwesenheit",
    from: "Von",
    to: "Bis",
    span: {
      FULLDAY: "Ganzer Tag",
      HALFDAY: "Halber Tag",
      // Ein Arzttermin von acht bis zehn: weder ganz noch halb, und gutgeschrieben wird genau seine Länge.
      CUSTOM: "Von bis",
    },
    // Die zwei Reiter des Tagesformulars. Eine leere Zelle ist entweder vergessene Zeit oder ein Grund,
    // warum niemand gearbeitet hat; beides beginnt am selben Klick.
    tab_time: "Zeit",
    tab_absence: "Abwesenheit",
    unpaid: "unbezahlt",
    conflicts_title:
      "Passt an einem Tag nicht neben die vorhandene Abwesenheit | Passt an {count} Tagen nicht neben die vorhandenen Abwesenheiten",
    conflicts_more: "und {count} weitere",
    conflict_skip: "Diese Tage auslassen, den Rest eintragen",
    conflict_replace: "An diesen Tagen die vorhandene Abwesenheit ersetzen",
    remove_day: "Tag entfernen",
    // Steht im Tagesfenster, wenn eine bezahlte Abwesenheit den Tag gutschreibt. Der Betrag steckt
    // schon im Saldo; gesagt wird er, weil er der Teil des Saldos ist, den niemand gearbeitet hat.
    credit: "Gutschrift {hours} auf das Arbeitszeitkonto",
    submit: "Eintragen",
    end_after_start: "Das Ende liegt vor dem Anfang.",
    // Unter dem Formular, weil beides erst nach dem Speichern auffallen würde.
    // Zwei halbe Tage oder ein halber Tag und ein Termin passen nebeneinander; ein ganzer Tag steht allein.
    hint: "Erscheint auch in der Personalplanung. Bezahlte Abwesenheiten werden dem Arbeitszeitkonto gutgeschrieben. Zwei halbe Tage passen auf einen Tag, ein ganzer Tag steht allein.",
    range: "{from} bis {to}",
    days: "{count} Tag | {count} Tage",
    // Eine abwesende Zelle öffnet jetzt ihren Dialog statt direkt das Formular, deshalb steht der Weg
    // zum Formular hier.
    create_time: "Zeit erfassen",
  },

  // ---------------------------------------------------------------------------------------------
  // Export und Nachweis.
  export: {
    certificate: "Monatsnachweis (PDF)",
    title: "Export",
    csv_german: "CSV (Excel, deutsch)",
    csv_german_hint: "Semikolon, Komma als Dezimaltrennzeichen",
    csv_technical: "CSV (technisch)",
    own_week: "Angezeigte Woche",
    failed: "Der Export konnte nicht erstellt werden.",
  },

  // ---------------------------------------------------------------------------------------------
  // Projektzeiten.
  project: {
    empty: "Auf dieses Projekt wurde im gewählten Zeitraum keine Zeit gebucht.",
    title: "Erfasste Zeiten",
    days: "Erfasste Tage",
    people: "Mitarbeiter",
    by_phase: "Nach Bauabschnitt",
    no_phase: "Ohne Bauabschnitt",
  },
  // Der Abschnitt unter den Summen im Projektregister Zeiten: gestempelte Tage gegen die
  // Stundenlohn- und Bautagesberichte desselben Projekts. „Gestempelt" statt „Erfasst", weil
  // „Erfasst" hier schon ein Status ist — und weil das Gegenüber, der Bericht, ebenfalls erfasst wird.
  reconciliation: {
    open_day: "Tag öffnen",
    empty:
      "Alles abgedeckt: Jeder gestempelte Tag steht in [[hwr:einem/einer/einem]] [[hwr]] oder [[cr:einem/einer/einem]] [[cr]].",
    title: "Abgleich mit Berichten",
    loading: "Abgleich wird geladen …",
    filter_all: "Alle",
    kind: {
      MISSING_REPORT: "Bericht fehlt",
      DEVIATION: "Abweichung",
    },
    missing_days: "Tage ohne Bericht",
    missing_hours: "Stunden ohne Bericht",
    deviations: "Abweichungen",
    column_tracked: "Gestempelt",
    column_reported: "Berichtet",
    column_difference: "Differenz",
    column_kind: "Befund",
    open_hourly_wage_report: "[[hwr:Zum/Zur/Zum]] [[hwr]]",
    open_construction_report: "[[cr:Zum/Zur/Zum]] [[cr]]",
    // {tolerance} kommt vom Server, schon als H:MM mit Einheit, z. B. „0:30 Std.".
    tolerance_note:
      "Als Abweichung zählt ein Unterschied von mehr als {tolerance}. [[cr:Beim/Bei der/Beim]] [[cr]] gilt die volle Schichtdauer.",
  },

  status: {
    OPEN: "Läuft",
    SUBMITTED: "Erfasst",
    APPROVED: "Freigegeben",
    REJECTED: "Abgelehnt",
  },
  source: {
    SELF: "Selbst erfasst",
    // Nicht "Für das Team erfasst": "Team"/"Trupp" ist im Produkt ein eigener Begriff, und die
    // Sammelerfassung geht an namentlich gewählte Mitarbeiter, nicht an einen Trupp.
    CREW: "Sammelerfassung",
    IMPORT: "Importiert",
  },
  // Womit ein Tag erfasst wurde. "Web" auch im Browser auf dem Handy — es ist dieselbe Anwendung;
  // "Mobile App" meint nur die App. "Unbekannt": das Gerät hat nicht gesagt, was es ist.
  capture_channel: {
    WEB: "Web",
    MOBILE: "Mobile App",
    UNKNOWN: "Unbekannt",
  },
  model: {
    empty: "Noch kein Arbeitszeitmodell angelegt.",
    // Der Spaltenkopf für genau ein Modell — die Listenüberschrift daneben steht im Plural.
    title_one: "Arbeitszeitmodell",
    title: "Arbeitszeitmodelle",
    // Der Dialog bearbeitet genau ein Modell — die Listenüberschrift stand vorher im Singularfall
    // im Plural darüber.
    title_create: "Arbeitszeitmodell anlegen",
    title_edit: "Arbeitszeitmodell bearbeiten",
    submit_create: "Anlegen",
    subtitle: "Vollzeit, Teilzeit und Schicht als Grundlage für Sollstunden und Pausenabzug.",
    add: "Modell anlegen",
    edit: "Modell bearbeiten",
    remove: "Modell entfernen",
    remove_title: "Arbeitszeitmodell entfernen?",
    // Gelöscht wird nur ein unbenutztes Modell: erfasste Tage rechnen ihre Pause aus dem Modell
    // (docs/archiving.md im Backend). Ein benutztes kommt ins Archiv.
    remove_text:
      "„{name}“ kann niemandem mehr zugeordnet werden. Wurden damit schon Zeiten erfasst oder ist es zugeordnet, bleibt alles unverändert und es kommt ins Archiv, wo du es jederzeit reaktivieren kannst. Sonst wird es gelöscht.",
    restore: "Modell reaktivieren",
    archived_section: "Archiviert ({count})",
    name: "Name",
    type: "Art",
    color: "Farbe",
    pick_color: "Farbe wählen",
    weekly_target_hours: "Wochenstunden",
    // Steht in der Modellliste hinter der Zahl. Vorher wurde dafür die Achsenbeschriftung der
    // Auswertung benutzt, sodass dort "40 Stunden" ohne Bezug zur Woche stand.
    weekly_hours_short: "Std./Woche",
    max_daily_hours: "Höchstarbeitszeit je Tag",
    rounding_minutes: "Rundung (Minuten)",
    // Sagt, was ein leeres Feld bedeutet. Vorher stand hier dauerhaft "Keine Rundung" — auch dann,
    // wenn eine eingetragen war.
    rounding_hint: "Leer lassen, wenn nicht gerundet werden soll.",
    limits: "Grenzen",
    day_column: "Tag",
    // Sagt die Regel, die den Schalter ersetzt hat: ein Tag ohne Soll ist keiner.
    days_hint: "Leeres Soll heißt: kein Arbeitstag.",
    day_off: "frei",
    // Erscheint erst, wenn wirklich jemand eine Null getippt hat. Leer und 0 sind im Backend zwei
    // verschiedene Aussagen, und ohne Schalter muss der Unterschied in Worten dastehen.
    zero_hint:
      "Ein Tag mit 0 erwartet null Stunden, alles Erfasste ist dort Mehrarbeit. Leer heißt dagegen: kein Arbeitstag.",
    week_sum_match: "Wochenmuster ergibt {hours} Std. und deckt sich mit den Wochenstunden.",
    week_sum_diff: "Wochenmuster ergibt {hours} Std., die Wochenstunden sagen {target}.",
    days: "Wochenmuster",
    target_hours: "Soll",
    planned_from: "Beginn",
    planned_to: "Ende",
    break_rules: "Pausenregeln",
    // Der Text nennt bewusst den Paragrafen: die Voreinstellung ist keine Erfindung von Lewara.
    break_rules_hint: "Ab {hours} Std. mindestens {minutes} Min. Pause (§ 4 ArbZG).",
    add_break_rule: "Regel hinzufügen",
    remove_break_rule: "Regel entfernen",
    // Nicht "Ab Stunden": gemeint ist die Arbeitszeit, ab der die Pause fällig wird.
    after_hours: "Ab Arbeitszeit (Std.)",
    min_minutes: "Mindestpause (Min.)",
    shift_templates: "Schichten",
    shift_templates_hint: "Nur für Schichtbetrieb. Die Nachtschicht darf über Mitternacht laufen.",
    add_shift: "Schicht hinzufügen",
    remove_shift: "Schicht entfernen",
    // Der Schalter im Dialog. Sagt, wofür der Standard da ist: er belegt beim Anlegen vor, mehr nicht.
    default_label: "Standard für neue Mitarbeiter",
    // Erscheint nur, wenn schon ein anderes Modell Standard ist: es verliert die Markierung beim Speichern.
    default_replaces: "Ersetzt „{name}“ als Standard.",
    // Chip in der Modellliste und Feldname im Änderungsprotokoll.
    default_chip: "Standard",
    // Beim Reiter Arbeitszeitmodelle: wer ab heute kein Modell hat, dem fehlt das Soll.
    unassigned: "{count} Mitarbeiter ohne Modell | {count} Mitarbeiter ohne Modell",
    unassigned_hint: "Ohne Modell hat ein Tag kein Soll und zählt nie als fehlend. Zum Zuweisen öffnen:",
    assignment: {
      title: "Arbeitszeitmodell",
      model: "Modell",
      valid_from: "Gültig ab",
      valid_to: "Gültig bis",
      // Im Eingabefeld: leer heißt „laufend“, und das Feld soll nicht wie eine Pflichtangabe aussehen.
      valid_to_optional: "Gültig bis (optional)",
      open_ended: "Laufend",
      add: "Wechsel eintragen",
      // Statt „Wechsel eintragen“, solange es noch keine Zuweisung gibt, die wechseln könnte.
      assign: "Modell zuweisen",
      // Beim Anlegen, unter der vorbelegten Zeile.
      prefilled: "Vorbelegt mit dem Standardmodell. „Gültig ab“ folgt dem Eintrittsdatum.",
      edit: "Zuweisung bearbeiten",
      // Steht unter der Zeile, bevor „Übernehmen“ die vorige Zuweisung beendet — damit nichts endet,
      // ohne dass es auf dem Bildschirm stand.
      closes_previous: "„{name}“ endet damit am {date}.",
      none: "Kein Modell zugewiesen",
      current: "Aktuell",
      remove: "Zuweisung entfernen",
      remove_title: "Zuweisung entfernen?",
      // Das Soll bereits erfasster Tage bleibt, weil es beim Erfassen mitgeschrieben wurde. Neu
      // erfasste Tage in diesem Zeitraum haben danach kein Soll mehr.
      remove_text:
        "Die Zuweisung wird entfernt. Bereits erfasste Zeiten behalten ihr Soll; neu erfasste Tage in diesem Zeitraum haben keines mehr.",
    },
  },
  weekday: {
    MONDAY: "Montag",
    TUESDAY: "Dienstag",
    WEDNESDAY: "Mittwoch",
    THURSDAY: "Donnerstag",
    FRIDAY: "Freitag",
    SATURDAY: "Samstag",
    SUNDAY: "Sonntag",
  },
  type: {
    FULL_TIME: "Vollzeit",
    PART_TIME: "Teilzeit",
    SHIFT: "Schichtbetrieb",
  },
}
